import React, {Suspense, useEffect} from "react";
import {RouterProvider} from "react-router-dom";
import {ConfigProvider} from "antd";
import {persistor, store} from '@arboxappv4/shared/src/redux/store'
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {siteRouter, kioskRouter} from "./Routing";
import './index.scss'
import SuspenseLoader from "./src/components/SuspenseLoader";
import {useTranslation} from "react-i18next";
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'
import {getAntTheme} from "./AntTheme";
import useProjectType from "./src/helpers/hooks/useProjectType";
import {kioskPersistor, kioskStore} from "@arboxappv4/shared/src/redux/kioskStandAlone/store";
import {projectTypes} from "@arboxappv4/shared/src/helpers/constants";
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: process.env.SENTRY_DSN, // Get this from your Sentry project settings
    environment: process.env.NODE_ENV || 'development',
    enabled: process.env.NODE_ENV === 'production',
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            maxReplayDuration: 1800000 //30 min session recording
        }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: true,
    // Block ALL other Sentry features
    beforeSend: () => null,              // No error events
    beforeSendTransaction: () => null,   // No performance events
    tracesSampleRate: 0,                 // No traces
});
// After init, start recording manually
if (process.env.NODE_ENV === 'production') {
    const replay = Sentry.getReplay();
    if (replay) {
        console.log('start recording')
        replay.start();
    }
}

Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
    onError: (event) => {
        const auth = store.getState().auth;
        const userBox = store.getState().user?.activeUsersBoxes;
        event.addMetadata('auth data', auth);
        if(userBox) {
            const email = auth.data?.email ?? ''
            event.setUser(userBox.user_fk, email, userBox.full_name);
        }
    },
})
BugsnagPerformance.start({ apiKey: process.env.BUGSNAG_API_KEY })
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const App = () => {
    const {i18n} = useTranslation()
    const projectType = useProjectType({})
    console.log('projectType',projectType)
    if(projectType) {
        return (
            <ErrorBoundary>
                <Provider store={projectType === projectTypes.site ? store : kioskStore}>
                    <PersistGate persistor={projectType === projectTypes.site ? persistor : kioskPersistor}>
                        <ConfigProvider
                            direction={i18n.dir()}
                            theme={getAntTheme()}>
                            <Suspense fallback={<SuspenseLoader/>}>
                                <RouterProvider router={projectType === projectTypes.site ? siteRouter : kioskRouter}/>
                            </Suspense>
                        </ConfigProvider>
                    </PersistGate>
                </Provider>
            </ErrorBoundary>
        );
    } else {
        return null
    }
}

export default App;

